import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
// 下载文件--get
function download_get(url) {
  window.location.href = url;
}

// 下载文件--post params是post请求需要的参数，url是请求url地址
function download_post(params, url) {
  var form = document.createElement('form');
  form.style.display = 'none';
  form.action = url;
  form.method = 'post';
  document.body.appendChild(form);

  var input = document.createElement('input');
  input.type = 'hidden';
  input.name = 'data';
  input.value = _JSON$stringify(params);
  form.appendChild(input);

  form.submit();
  form.remove();
}

var download = {
  download_get: download_get,
  download_post: download_post
};
export default download;


//////////////////
// WEBPACK FOOTER
// ../vue-common-laboratory/dist/utils/download.js
// module id = null
// module chunks = 